import { UserData, Director } from "../../../../types/org.type";

/**
 * Returns the users that should be shown in the National Identity section.
 * - Individual routes: all users
 * - Org routes: only users with jobTitle "Director" whose email appears in boardOfDirectors
 */
export const getDirectorUsers = (
  users: UserData[] | undefined,
  boardOfDirectors: Director[] | undefined,
  isOrgRoute: boolean
): UserData[] => {
  if (!users?.length) return [];

  if (!isOrgRoute) return users;

  const boardEmails = (boardOfDirectors || [])
    .filter((d) => d?.email)
    .map((d) => d.email.toLowerCase().trim());

  return users.filter((user) => {
    const hasDirectorJobTitle = user?.jobTitle === "Director";
    const isInBoardOfDirectors = boardEmails.includes(user?.email?.toLowerCase());
    return hasDirectorJobTitle && isInBoardOfDirectors;
  });
};
